import React from "react";
import { Paper } from "@mui/material";

const Footer = () => {
    return (
        <footer>
            <Paper
                sx={{
                    display: "flex",
                    p: "var(--mscp-padding-vertical) var(--mscp-padding-gorizontal)",
                    justifyContent: "space-between",
                    alignItems: "center",
                    backgroundColor: "var(--mscp-p-111-7-c)",
                    color: "var(--mscp-color-white)",
                }}
                square
            ></Paper>
        </footer>
    );
};

export default Footer;
